module.exports = __webpack_public_path__ + "static/media/cocktail.8389ed96.png";